<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('sparePartReplacement.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('sparePartReplacement.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div
          class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3"
        >
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-tooltip="$t('sparePartReplacement.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="ts-text-xs">{{
                    $t('sparePartReplacement.branchName')
                  }}</label>
                  <ts-branch-filter
                    @filter="branchFilter"
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
              <div class="row ts-mt-3">
                <div class="col-md-12">
                  <label class="ts-text-xs">{{
                    $t('sparePartReplacement.location')
                  }}</label>
                  <ts-location-filter
                    :isDefaultSelect="false" 
                    :showPlaceholder="false" 
                    @filter="filterLocaton"></ts-location-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td>{{ record.branch.branch_name_en }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.replacement_number }}
            </td>
            <td>{{ record.product.product_name_en }}</td>
            <td>{{ record.serial_no }}</td>
            <td>{{ record.location.location_name_en }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.replacement_date }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.remarks }}
            </td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto">
              <thead>
                <tr>
                  <th>{{ $t('sparePartReplacement.productName') }}</th>
                  <th>{{ $t('sparePartReplacement.uom') }}</th>
                  <th class="text-center">{{ $t('sparePartReplacement.quantity') }}</th>
                  <th>{{ $t('sparePartReplacement.remark') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(detail, index) in prop.record.replacement_details" :key="index">
                 <td>{{  detail.product_name }}</td>
                 <td>{{  detail.uom_name}}</td>
                 <td class="text-center">{{  detail.quantity}}</td>
                 <td>{{  detail.remarks }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'wholesaleReceipt',
  data() {
    return {
      loading: false,
      errors: new Errors(),
    }
  },
  created() {
		 this.$store.state.wholesale.replacement.dateRange = [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')]
    this.fetchData()
  },
  computed: {
    ...mapState('wholesale/replacement', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.wholesale.replacement.search
      },
      set(newValue) {
        this.$store.commit('wholesale/replacement/SET_SEARCH', newValue)
        this.$store.commit('wholesale/replacement/RESET_CURRENT_PAGE')
      },
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.replacement.dateRange
      },
      set(newValue) {
        this.$store.commit('wholesale/replacement/SET_DATE_RANGE', newValue)
      },
    },
    columns() {
      return [
        { name: this.$t('sparePartReplacement.branchName') },
        { name: this.$t('sparePartReplacement.number') },
        { name: this.$t('sparePartReplacement.productNameEn') },
        { name: this.$t('sparePartReplacement.serialNumber') },
        { name: this.$t('sparePartReplacement.location') },
        { name: this.$t('sparePartReplacement.date') },
        { name: this.$t('sparePartReplacement.remark') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%',
        },
      ]
    },
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'spare-part-replacement-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/replacement/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('wholesale/replacement/destroy', record.replacement_id)
        .then((response) => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    branchFilter(value) {
      this.$store.commit('wholesale/replacement/SET_BRANCH_ID', value)
      this.fetchData()
    },
    edit(record) {
      this.$store.commit('wholesale/replacement/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'spare-part-replacement-edit',
        params: { id: record.replacement_id },
      })
    },
    filterLocaton(value){
      this.$store.commit('wholesale/replacement/SET_LOCATION_ID', value)
      this.fetchData()
    }
    
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/replacement/RESET_STATE')
    next()
  },
}
</script>